/**
 * The `?` in the corner of every page.
 *
 * The owner's requirement, stated plainly: a user should be able to learn how
 * to do anything without asking anyone, and the way in is a `?` on the page
 * they are already looking at.
 *
 * It resolves the current route to an article rather than opening a generic
 * index, because "help" that lands somebody on a list of twenty-four articles
 * has made them do the work themselves.
 */

import { Link, useLocation } from 'react-router-dom';
import { helpSlugForPath } from './useHelp';
import own from './Help.module.css';

export function HelpButton() {
  const { pathname } = useLocation();
  const slug = helpSlugForPath(pathname);

  return (
    <Link
      to={`/help/article/${slug}`}
      className={own.helpBtn}
      // The glyph alone reads as "question mark" to a screen reader, which is
      // not what it does.
      aria-label="Help for this page"
      title="Help for this page"
    >
      <span aria-hidden="true">?</span>
    </Link>
  );
}
